import { KeyValue } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Ordena los resultados de un `keyvalue` pipe por fecha (dd/MM/yyyy) de más antigua a más reciente.
 */
@Pipe({
  name: 'orderKeyValueByDate',
  standalone: true,
})
export class OrderKeyValueByDatePipe implements PipeTransform {
  transform(keyValueArray: KeyValue<string, any>[]): KeyValue<string, any>[] {
    if (!Array.isArray(keyValueArray)) {
      return [];
    }

    return [...keyValueArray].sort((a, b) => this.parseDate(b.key) - this.parseDate(a.key));
  }

  private parseDate(dateString: string): number {
    if (!dateString) {
      return Number.MAX_SAFE_INTEGER;
    }

    const [day, month, year] = dateString.split('/').map(Number);

    if ([day, month, year].some((value) => Number.isNaN(value))) {
      return Number.MAX_SAFE_INTEGER;
    }

    return new Date(year, month - 1, day).getTime();
  }
}

